import { ExternalAuthError, ExternalAuthFlow } from '@account/account-portal/external-auth'

import { AuthHandler, HandlerContext } from './handler-types'
import { createKmcHandler } from './kmc'
import { createSocialLoginHandler } from './social-login'

export function getHandler(flow: ExternalAuthFlow, context: HandlerContext): AuthHandler {
  switch (flow.method) {
    case 'kmc':
      return createKmcHandler(flow, context)

    case 'social-login':
      return createSocialLoginHandler(flow, context)

    default:
      throw new ExternalAuthError(`Invalid method: ${flow.method}`)
  }
}
